<template>
  <div class="new-page-wrapper">
    <div class="new-page-content">
      <h1 class="title">ဂိမ္းဗားရွင္းသစ္သတင္း</h1>
      <div class="new-paragraph">
        <p>1-ယခုဗားရွင္းသစ္ျပဳျပင္မြမ္းမံၿပီးပုိကာ Texas ေဆာ့လုိ႔ရပါျပီ။ဂိမ္းဒုိင္သစ္ေျပာင္းၿပီ။</p>
        <p>ၾကည့္လုိက္ေဆာ့ျခင္းခံစားလုိက္ျခင္းပုိေကာင္းေအာင္လုပ္ေပးသည္။</p>
        <p>သင္သည္ဖဲသစ္ပုိကာ Texas ကုိမေဆာ့တတ္ေသးလွ်င္ယခုဂိမ္းကစားဝုိင္းဝင္ၿပီး</p>
        <p>ေသခ်ာဂိမ္းစည္းမ်ဥ္းခ်က္ေတြကုိၾကည့္ုႏုိင္သည္။</p>
        <p>ေဆာ့ျခင္းပိတ္ခ်င္လွ်င္ -အခန္းေျပာင္း- ႏွိပ္ၿပီးေျပာင္းမယ္။ထြက္မလုိအပ္ပါ။</p>
      </div>

      <div class="new-paragraph">
        <p>2- ယခုကေတာ့ဖဲေဆာ့ၿပီးဆုလာဘ္ႀကီးေတြကိုလဲႏုိင္မည္။</p>
        <p>ထုိးေၾကးေရာဖုန္းေဘပါကုိစုေဆာင္းအမွတ္ျပည့္စံုလွ်င္လဲရပါ့လိမ့္မည္။</p>
        <p>ကစားဝုိင္းထဲတြင္ဖဲေဆာ့ႏုိင္ေသာပြဲသည္ 5 ပြဲရွိလွ်င္စုေဆာင္းအမွတ္ရႏုိင္မည္။</p>
        <p>ကစားဝုိင္းျမင့္ေလေလရႏုိင္ေသာစုေဆာင္းအမွတ္မ်ားေလေလျဖစ္ပါသည္။</p>
        <p>ဂိမ္းဝင္ေသာအသစ္ကစားသမားမ်ားျဖစ္လွ်င္သစ္လူျဖစ္ေသာဆုလာဘ္သည္သံုးရက္ထဲရွိသည္။</p>
        <p>ပုိမ်ားေသာထုိးေၾကးႏွင့္ပုိမ်ားေသာစုေဆာင္း</p>
        <p>လ်င္ျမန္ေဒါင္းလုပ္ၿပီးဖဲကုိသြားေဆာ့ပါရွင္။ပုိမ်ားဆုလာဘ္ေတြကုိရႏုိင္ပါသည္။</p>
        <p></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less">
@import "~src/styles/Normalize";
@import "~src/styles/index";
@import "~src/styles/new";
</style>